import { EmergencyContactItemDto } from '@/api/generated';
import { EmergencyContactsSearchFormModel } from '@/views/emergencyContacts/list/components/table/model/EmergencyContactsSearchForm.model.ts';

export type EmergencyContactsListTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<EmergencyContactItemDto, 'id'>, string>;
    head: Record<keyof EmergencyContactsSearchFormModel, string>;
    row: {
      statusOptions: Record<string, string>;
    };
  };
};

export const emergencyContactsListTranslation: EmergencyContactsListTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      category: 'Kategoria',
      email: 'Email',
      name: 'Nazwa',
      phoneNumber: 'Numer telefonu',
      status: 'Status',
    },
    head: {
      categories: 'Kategorie',
      fullTextSearchInput: 'Szukaj',
      status: 'Status',
    },
    row: {
      statusOptions: {
        Active: 'Aktywny',
        Inactive: 'Nieaktywny',
      },
    },
  },
};
